/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyContactHistoryModel } from '../../models/client-survey-contact-history-model';

export interface GetSurveyContactHistoriesAsync$Json$Params {

/**
 * surveycontact id filter
 */
  surveyContactId: number;
}

export function getSurveyContactHistoriesAsync$Json(http: HttpClient, rootUrl: string, params: GetSurveyContactHistoriesAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyContactHistoriesAsync$Json.PATH, 'get');
  if (params) {
    rb.query('surveyContactId', params.surveyContactId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyContactHistoryModel>>;
    })
  );
}

getSurveyContactHistoriesAsync$Json.PATH = '/api/SurveyContactHistory';
